import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { keepBlockSelectionAttribute } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/constants'

export const Container = styled.div.attrs({ [keepBlockSelectionAttribute]: '' })`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  width: 276px;
`

export const Description = styled(Text)`
  color: ${props => props.theme.colors.text.muted};
`

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
`
